import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { ArrowRight, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { inputCls, btnPrimary } from "@/pages/Auth";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [valid, setValid] = useState(token ? null : false);

  useEffect(() => {
    if (!token) return;
    api.get("/auth/reset-password/check", { params: { token } })
      .then((r) => setValid(!!r.data.valid))
      .catch(() => setValid(false));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== confirm) {
      toast.error("Konfirmasi password tidak sama");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      toast.success("Password berhasil diperbarui");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  if (valid === false) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50 p-6 text-center" data-testid="reset-password-invalid">
        <div>
          <p className="font-black text-xl text-slate-900">Tautan tidak valid</p>
          <p className="mt-2 text-sm text-slate-500">Tautan ini sudah dipakai, kedaluwarsa, atau tidak valid. Minta tautan atur ulang password baru dari halaman login.</p>
          <Link to="/login" className="inline-block mt-5 font-bold text-blue-600">← Kembali ke Login</Link>
        </div>
      </div>
    );
  }

  if (valid === null) {
    return <div className="min-h-screen grid place-items-center bg-slate-50" data-testid="reset-password-checking"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>;
  }

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 p-6">
      <div className="w-full max-w-sm bg-white rounded-3xl p-7 shadow-2xl" data-testid="reset-password-page">
        <Link to="/" className="flex items-center mb-6"><Logo className="h-8" /></Link>
        {done ? (
          <div className="text-center" data-testid="reset-password-success">
            <p className="font-black text-xl text-slate-900">Password Diperbarui</p>
            <p className="mt-2 text-sm text-slate-500">Silakan masuk dengan password baru Anda.</p>
            <button onClick={() => navigate("/login")} data-testid="reset-goto-login-button" className={`${btnPrimary} w-full mt-5`}>Ke Halaman Login <ArrowRight className="w-4 h-4" /></button>
          </div>
        ) : (
          <>
            <h1 className="text-2xl font-black text-slate-900">Atur Ulang Password</h1>
            <p className="mt-1 text-sm text-slate-500">Buat password baru untuk akun Anda.</p>
            <form onSubmit={submit} className="mt-5 space-y-3">
              <input data-testid="reset-password-input" type="password" minLength={6} className={inputCls} placeholder="Password baru (min. 6 karakter)" value={pw} onChange={(e) => setPw(e.target.value)} required />
              <input data-testid="reset-password-confirm-input" type="password" minLength={6} className={inputCls} placeholder="Konfirmasi password baru" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
              <button data-testid="reset-password-submit-button" disabled={loading} className={`${btnPrimary} w-full`}>{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Simpan Password Baru"}</button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
